import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';
import { theme } from '../theme';
import { ToggleButton } from '../toggleButton';
import { ToastType } from './ToastType';

export interface StyledToastProps {
  type?: ToastType;
}

export const StyledToastOverlay = styled.div``;

export const StyledToastContainer = styled.div<StyledToastProps>`
  display: inline-flex;
  justify-content: space-between;
  padding: 1rem;
  color: ${theme.colors.primaryW};

  border-radius: 0.3rem;

  background-color: ${(props) => {
    if (props.type === ToastType.Info) {
      return theme.colors.primaryT2;
    }

    if (props.type === ToastType.Urgent) {
      return theme.colors.primaryR5;
    }

    return theme.colors.primaryT2;
  }};

  width: 100%;

  ${mediaQuery('md')} {
    width: 26.25rem;
  }
`;

export const StyledIconContainer = styled.div`
  height: 1.25rem;
  width: 1.25rem;
  margin: 0.3rem 1rem 0 0;

  svg {
    height: 100%;
    width: 100%;

    g,
    path {
      fill: ${theme.colors.primaryW};
    }
  }
`;

export const StyledTextContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
`;

export const StyledTitle = styled.div`
  font-size: ${theme.fontSizes.h4};
  font-weight: ${theme.fontWeight.bold};
`;

export const StyledText = styled.span`
  font-size: ${theme.fontSizes.body};
`;

export const StyledCloseButton = styled(ToggleButton)`
  margin: 0.3rem 0 0 1rem;
  height: 1.25rem;
  width: 1.25rem;
`;
